import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { actions } from "redux/User/action";
import CodeInput from "./CodeInput";
import MfaEnrol from "./MfaEnrol";
import { loginWithCode, mfaError } from "utils/mfaApi";
import { takePostLoginPath } from "utils/postLogin";

// The step between "password accepted" and "signed in".
const MfaLoginStep = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mfa } = useSelector((state) => state.user);
  const [recovery, setRecovery] = useState(false);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const back = () => dispatch({ type: actions.USER_MFA_CLEAR });

  const finish = ({ token, refreshToken }) => {
    localStorage.setItem("TOKEN", token);
    localStorage.setItem("REFRESH_TOKEN", refreshToken);
    dispatch({ type: actions.USER_MFA_CLEAR });
    navigate(takePostLoginPath());
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!recovery && code.length !== 6) return setError("Enter the 6-digit code from your app.");
    if (recovery && !code) return setError("Enter a recovery code.");
    setBusy(true);
    setError("");
    try {
      const res = await loginWithCode(mfa.mfaToken, recovery ? { recoveryCode: code } : { code });
      finish(res.data.result);
    } catch (err) {
      setError(mfaError(err, "That code didn't work. Try again."));
      setCode("");
    } finally {
      setBusy(false);
    }
  };

  if (mfa.mfaSetupRequired) {
    return (
      <div>
        <h1 className="cc-auth__title">Set up two-step sign-in</h1>
        <MfaEnrol
          token={mfa.mfaToken}
          intro="Your account needs two-step sign-in. Set it up now to continue."
          onDone={finish}
          onCancel={back}
        />
      </div>
    );
  }

  return (
    <form onSubmit={submit}>
      <h1 className="cc-auth__title">Two-step sign-in</h1>
      <div className="mfa-card">
        <p className="mfa-lead">
          {recovery
            ? "Enter one of your recovery codes. Each one works once."
            : "Enter the 6-digit code from your authenticator app."}
        </p>
        <CodeInput key={recovery ? "r" : "c"} value={code} onChange={setCode} recovery={recovery} />
        {error && <p className="mfa-error">{error}</p>}
        <div className="mfa-actions">
          <button type="submit" className="mfa-primary-btn" disabled={busy}>
            Continue
          </button>
          <button
            type="button"
            className="mfa-link"
            onClick={() => {
              setRecovery(!recovery);
              setCode("");
              setError("");
            }}
          >
            {recovery ? "Use my authenticator app" : "Use a recovery code"}
          </button>
        </div>
        <div className="mfa-actions" style={{ marginTop: 8 }}>
          <button type="button" className="mfa-link" onClick={back}>
            Back to login
          </button>
        </div>
      </div>
    </form>
  );
};

export default MfaLoginStep;
